import { Components, Inputs } from "@thisgorilla/primate-ds";
import { useState } from "react";
import { useTheme } from "styled-components";

import { Divider } from "../../../../../../../commonStyles";
import { useAppSelector } from "../../../../../../../redux";
import CircleCreatedSuccess from "../../../../../../../svg/Circle-Created-Success.svg";
import ColorPicker from "../../../../../../Common/ColorPicker";
import Loader from "../../../../../../Common/Loader";
import CircleModalProps from "../CircleModal";
import {
  CloseButtonContainer,
  ColorPickerContainer,
  Container,
  Image,
  RelativeContainer,
  SelectedColor,
  Wrapper,
} from "./style";

const ModalContent = ({
  color,
  setColor,
  setCircleName,
  circleName,
  isSuccessModal,
}: CircleModalProps.ModalContentProps) => {
  const { Color } = useTheme();
  const [showColorPicker, setShowColorPicker] = useState(false);
  const { createCircle_API_STATUS } = useAppSelector((state) => state.circle);

  return (
    <>
      <Image
        src={CircleCreatedSuccess}
        alt="Circle-Created-Success"
        $isSuccessModal={isSuccessModal}
      />
      {!isSuccessModal && (
        <Container $gapInPx={8}>
          <Divider $color={Color.border["ui-border-subtle"].value} />
          <Inputs.Input
            onChangeHandler={(value) => setCircleName(value)}
            value={circleName}
            fieldName="colleagues"
            idPrefix="colleagues"
            placeholder="Colleagues"
            isRequired={false}
            showLabel
            label="Label"
            size="Small"
          />
          <ColorPickerContainer>
            <SelectedColor $background={color} />
            <Components.IconButton
              disabled={false}
              iconType="Plus"
              kind="Tertiary"
              size="XS"
              onClick={() => setShowColorPicker(true)}
            />
          </ColorPickerContainer>
          <Divider $color={Color.border["ui-border-subtle"].value} />
          {showColorPicker && (
            <RelativeContainer>
              <Wrapper $gapInPx={16}>
                <ColorPicker color={color} setColor={setColor} />
              </Wrapper>
              <CloseButtonContainer>
                <Components.IconButton
                  iconType="X"
                  kind="Tertiary"
                  size="XS"
                  disabled={false}
                  onClick={() => setShowColorPicker(false)}
                />
              </CloseButtonContainer>
              {createCircle_API_STATUS === "progress" && <Loader />}
            </RelativeContainer>
          )}
        </Container>
      )}
    </>
  );
};

export default ModalContent;
